import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=53bfee5d&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"
import style0 from "./Navigation.css?vue&type=style&index=0&id=53bfee5d&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bfee5d",
  null
  
)

export default component.exports